import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router-dom";
import { Alert } from "reactstrap";

import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 40,
  },
  button: {
    margin: "5px",
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const UpdateNumbers = () => {
  const classes = useStyles();

  const { rangeId } = useParams();

  const [formData, setFormData] = useState({
    range: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken(`api/Ranges/${rangeId}`)
      .then((res1) => res1.json())
      .then((data1) => {
        setFormData({
          range: data1,
          loading: false,
        });
      });
  }, []);

  return (
    <>
      {formData.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <EditForm data={formData} />
      )}
    </>
  );
};

const EditForm = ({ data: data }) => {
  const classes = useStyles();
  const history = useNavigate();
  const range = data.range;

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const [rangeNumbersData, setRangeNumbersData] = useState({
    id: range.id,
    startNumber: range.startNumber,
    endNumber: range.endNumber,
  });

  const myChangeHandler = (e) => {
    setRangeNumbersData({
      ...rangeNumbersData,
      [e.target.name]: e.target.value,
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (
      rangeNumbersData.startNumber == "" ||
      rangeNumbersData.startNumber == null
    )
      setRangeNumbersData({
        ...rangeNumbersData,
        startNumber: range.startNumber,
      });
    if (rangeNumbersData.endNumber == "" || rangeNumbersData.endNumber == null)
      setRangeNumbersData({ ...rangeNumbersData, endNumber: range.endNumber });
    if (
      rangeNumbersData.startNumber.length < 9 ||
      rangeNumbersData.startNumber.length > 13 ||
      rangeNumbersData.endNumber.length < 9 ||
      rangeNumbersData.endNumber.length > 13
    ) {
      sendAlert("Numbers Must Be 9 To 13 Digits Long", "danger");
      return;
    }
    if (
      rangeNumbersData.startNumber == range.startNumber &&
      rangeNumbersData.endNumber == range.endNumber
    ) {
      sendAlert("No Changes Made From Original Range Numbers", "danger");
      return;
    }
    if (rangeNumbersData.startNumber >= rangeNumbersData.endNumber) {
      sendAlert("End Number must be greater than Start Number", "danger");
      return;
    }
    if (rangeNumbersData.startNumber < 0 || rangeNumbersData.endNumber < 0) {
      sendAlert("Negative Numbers Not Accepted.", "danger");
      return;
    }

    const count = rangeNumbersData.endNumber - rangeNumbersData.startNumber + 1;

    if (count > 1000) {
      sendAlert("Range Can Be No Longer Than 1000 Numbers", "danger");
      return;
    }

    fetchWithToken(`api/Ranges/UpdateNumbers/`, "PUT", rangeNumbersData).then(
      (res) => {
        if (!res.ok) {
          if (res.status === 412)
            sendAlert(
              `Active Endpoint(s) Associated With New Range Numbers`,
              "warning"
            );
          else if (res.status === 413)
            sendAlert(
              `New Range Phone Number(s) Already Exist In Other Range`,
              "warning"
            );
          else sendAlert(`Error`, "warning");
        } else {
          sendAlert(`Successfully Updated`, "success");
          history(`/ranges/edit/${rangeNumbersData.id}`);
        }
      }
    );
  };

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });

    const timer = setTimeout(() => {
      setAlertMessage({
        message: "",
        varient: "",
        active: false,
      });
    }, 8500);
  };

  return (
    <>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <Card className={classes.card}>
            {alertMessage.active && (
              <Alert color={alertMessage.varient}>{alertMessage.message}</Alert>
            )}
            <CardContent>
              <Typography
                sx={{ fontSize: 14 }}
                style={{ margin: "20px", fontSize: "1.5em" }}
                color="text.secondary"
                gutterBottom
                variant="h6"
                id="tableTitle"
                component="div"
              >
                Update Numbers For Range Id: {range.id}
              </Typography>

              <form onSubmit={submitHandler}>
                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label htmlFor="startNumber" class="col-sm-4 col-form-label">
                    <h6>New Start Number:</h6>
                  </label>
                  <div class="col-sm-8">
                    <input
                      type="number"
                      class="form-control"
                      name="startNumber"
                      placeholder={range.startNumber}
                      defaultValue={range.startNumber}
                      maxlength="13"
                      onChange={(e) => myChangeHandler(e)}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label htmlFor="endNumber" class="col-sm-4 col-form-label">
                    <h6>New End Number:</h6>
                  </label>
                  <div class="col-sm-8">
                    <input
                      type="number"
                      class="form-control"
                      name="endNumber"
                      placeholder={range.endNumber}
                      defaultValue={range.endNumber}
                      maxlength="13"
                      onChange={(e) => myChangeHandler(e)}
                    />
                  </div>
                </div>

                {range.totalCount ===
                  range.endNumber - range.startNumber + 1 && (
                  <Button
                    type="submit"
                    variant="contained"
                    className={classes.button}
                    color="primary"
                  >
                    Update
                  </Button>
                )}
                <Button
                  variant="contained"
                  className={classes.button}
                  onClick={() => history(`/ranges/edit/${range.id}`)}
                >
                  Cancel
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default UpdateNumbers;
